import { lazy } from 'react'

/**
 * Módulo: Casos
 * Entidad transversal — expedientes investigativos con conversación,
 * participantes internos+externos, vínculos a recursos y tareas.
 * Origen polimórfico (webhooks ML, manual, regla, otra plataforma).
 *
 * Ver: docs/casos.md, docs/MODELO_ORGANIZACIONAL.md
 */
export default {
  id: 'casos',
  nombre: 'Casos',
  descripcion: 'Gestor de casos transversal — reclamos, devoluciones, auditorías, consultas',
  icono: 'folder',
  tipo: 'core',
  version: '0.1.0',
  // Etapa 1: consultor central. Etapa 2/3: admin-empresa también.
  // Visible para consultor + admin Milbrands. Cliente con vista 'admin-empresa'
  // o 'supervisor-empresa' lo verá cuando se asigne ese permiso en su vista.

  routes: [
    { path: 'casos',            component: lazy(() => import('./pages/CasosPage')) },
    { path: 'mis-casos',        component: lazy(() => import('./pages/MisCasosPage')) },
    { path: 'casos/:casoId',    component: lazy(() => import('./pages/CasoDetailPage')) },
    { path: 'casos-analytics',  component: lazy(() => import('./pages/CasosAnalyticsPage')) },
    // Portal externo (acceso anónimo vía magic link JWT firmado)
    // NO requiere auth Firebase — todas las operaciones pasan por callables
    // que validan el JWT con MAGIC_LINK_SECRET.
    { path: 'p/caso/:token',   component: lazy(() => import('./public/PortalCasoPage')), public: true },
  ],

  // #87 — `permisoModulo` filtra item-by-item según el rol.
  // Sin ítems de menú propios → el grupo CASOS ya no aparece en el sidebar.
  //  • "Casos" vive en el grupo SUPERVISIÓN (supervision/config.js).
  //  • "Mis casos" vive en el grupo GESTIÓN (gestion/config.js).
  //  • "Analytics" (7-jul, Mariano) pasó a ser un BOTÓN en el header de la
  //    página Casos (CasosPage.jsx → link a /casos-analytics), ya no un ítem
  //    del sidebar. La ruta /casos-analytics sigue en `routes`.
  menuItems: [],

  features: [
    'casos',
    'case-feed',
    'multi-sla',
    'portal-externo',
    'casos-analytics',
  ],

  // permisoModulos (#58): se deriva del rol.
  permisoModulos: ['casos'],

}
